import gql from 'graphql-tag';

export const updateProductCategoryQuery = gql`
  mutation updateProductCategory(
    $updateProductCategoryRequest: UpdateProductCategoryRequest!
  ) {
    updateProductCategory(
      updateProductCategoryRequest: $updateProductCategoryRequest
    ) {
      productCategory {
        productCategoryId
        name
        description
        productType
        groupId
        groupType
      }
    }
  }
`;
